(function () {
  "use strict";

  /*
    SPARC CONFIGURATOR COMPLETION V1.4
    Shared confirmed-completion enhancement.

    Completion now requires TWO conditions:
    1) the current section is fully valid/complete
    2) the customer leaves that tab by clicking another tab

    Only then is the section committed as complete and the celebration
    animation is shown.

    No configurator core files are modified.
  */

  if (window.__SPARC_CONFIGURATOR_COMPLETION_V1_4__) return;
  window.__SPARC_CONFIGURATOR_COMPLETION_V1_4__ = true;

  var PANEL_IDS = [
    "sparc-muscle-configurator",
    "sparc-muscle-round-configurator",
    "sparc-driver-configurator",
    "sparc-heritage-configurator",
    "sparc-classic-3100-configurator",
    "sparc-classic-squarebody-configurator",
    "sparc-garage-configurator"
  ];

  var OPTIONAL_SECTIONS = {
    accessories: true
  };

  var panel = null;
  var sectionMap = {};
  var observer = null;
  var updateTimer = null;
  var startupTimer = null;

  var activeSectionName = "";
  var committedSections = {};
  var incompleteSections = {};
  var touchedSections = {};

  function q(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qa(sel, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(sel)
    );
  }

  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function visible(node) {
    if (!node) return false;

    var style = window.getComputedStyle(node);
    var rect = node.getBoundingClientRect();

    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      node.hidden !== true &&
      node.getAttribute("aria-hidden") !== "true" &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function activePanel() {
    for (var i = 0; i < PANEL_IDS.length; i++) {
      var candidate =
        document.getElementById(PANEL_IDS[i]);

      if (
        candidate &&
        visible(candidate) &&
        q(".sparc-config-tabs", candidate) &&
        q(".sparc-accordion-list", candidate)
      ) {
        return candidate;
      }
    }

    return qa(
      '[id^="sparc-"][id$="-configurator"]'
    ).find(function (candidate) {
      return (
        visible(candidate) &&
        q(".sparc-config-tabs", candidate) &&
        q(".sparc-accordion-list", candidate)
      );
    }) || null;
  }

  function normalizeTabName(text) {
    var value =
      clean(text)
        .replace(/✓/g, "")
        .toLowerCase();

    if (/horn\s*ring/.test(value)) return "hornRing";
    if (/finish/.test(value)) return "finish";
    if (/grip/.test(value) && !/leather/.test(value)) return "grip";
    if (/leather/.test(value)) return "leather";
    if (/horn/.test(value)) return "horn";
    if (/mount/.test(value)) return "mounting";
    if (/accessor/.test(value)) return "accessories";
    if (/summary/.test(value)) return "summary";

    return value
      .replace(/[^a-z0-9]+/g, "")
      .trim();
  }

  function createTabBadge() {
    var wrap =
      document.createElement("span");

    wrap.className =
      "sparc-tab-complete-mark";

    wrap.setAttribute(
      "aria-hidden",
      "true"
    );

    /*
      No check icon on the upper tabs.
      This full-tab overlay is used only for the completed emerald rail
      and the brief premium gold/white specular sweep.
    */
    wrap.innerHTML =
      '<span class="sparc-tab-complete-mark__rail"></span>' +
      '<span class="sparc-tab-complete-mark__sheen"></span>';

    return wrap;
  }

  function createAccordionBadge() {
    var wrap =
      document.createElement("span");

    wrap.className =
      "sparc-accordion-complete-mark";

    wrap.setAttribute(
      "aria-hidden",
      "true"
    );

    wrap.innerHTML =
      '<span class="sparc-accordion-complete-mark__ring"></span>' +
      '<span class="sparc-accordion-complete-mark__core">' +
        '<svg viewBox="0 0 20 20" focusable="false">' +
          '<path class="sparc-mark-check" d="M6 10.2l2.45 2.45 5.6-5.65"></path>' +
          '<path class="sparc-mark-x sparc-mark-x--a" d="M6.5 6.5l7 7"></path>' +
          '<path class="sparc-mark-x sparc-mark-x--b" d="M13.5 6.5l-7 7"></path>' +
        '</svg>' +
      '</span>' +
      '<span class="sparc-accordion-complete-mark__glint"></span>';

    return wrap;
  }

  function ensureTabBadge(tab) {
    if (!tab) return null;

    var existing =
      q(
        ":scope > .sparc-tab-complete-mark",
        tab
      );

    if (existing) return existing;

    var badge =
      createTabBadge();

    tab.appendChild(
      badge
    );

    return badge;
  }

  function ensureAccordionBadge(head) {
    if (!head) return null;

    var existing =
      q(
        ":scope > .sparc-accordion-complete-mark",
        head
      );

    if (existing) return existing;

    var badge =
      createAccordionBadge();

    var summary =
      q(
        ".sparc-accordion__summary",
        head
      );

    if (summary) {
      head.insertBefore(
        badge,
        summary
      );
    } else {
      head.appendChild(
        badge
      );
    }

    return badge;
  }

  function buildMap() {
    if (!panel) return false;

    sectionMap = {};

    var sections =
      qa(
        ".sparc-accordion[data-section]",
        panel
      );

    var tabs =
      qa(
        ".sparc-config-tabs .sparc-config-tab",
        panel
      );

    sections.forEach(
      function (section, index) {
        var name =
          section.dataset.section ||
          "";

        if (!name) return;

        var head =
          q(
            ".sparc-accordion__head",
            section
          );

        var tab = null;

        if (
          tabs[index] &&
          (
            tabs.length === sections.length ||
            normalizeTabName(
              tabs[index].textContent
            ) === name
          )
        ) {
          tab = tabs[index];
        } else {
          tab =
            tabs.find(
              function (candidate) {
                return (
                  normalizeTabName(
                    candidate.textContent
                  ) === name
                );
              }
            ) || null;
        }

        sectionMap[name] = {
          name: name,
          section: section,
          head: head,
          tab: tab,
          tabBadge:
            ensureTabBadge(
              tab
            ),
          headBadge:
            ensureAccordionBadge(
              head
            ),
          valid: false,
          committed: false,
          incomplete: false
        };

        if (tab) {
          tab.dataset.sparcCompletionSection =
            name;
        }

        if (head) {
          head.dataset.sparcCompletionSection =
            name;
        }
      }
    );

    return (
      Object.keys(
        sectionMap
      ).length > 0
    );
  }

  function invalidSummaryText(text) {
    var value =
      clean(text).toLowerCase();

    if (!value) return true;

    return (
      value === "not selected" ||
      value === "—" ||
      value === "-" ||
      value === "select" ||
      value.indexOf("required") !== -1 ||
      value.indexOf("selection required") !== -1 ||
      value.indexOf("selections required") !== -1
    );
  }

  function selectedIn(root, selectors) {
    if (!root) return false;

    return selectors.some(
      function (selector) {
        return !!q(
          selector,
          root
        );
      }
    );
  }

  function selectHasValue(select) {
    if (!select) return false;

    return (
      String(
        select.value || ""
      ).trim() !== ""
    );
  }

  function visibleConditionalBlocks(section) {
    return qa(
      ".sparc-conditional.is-visible",
      section
    ).filter(visible);
  }

  function customUploadComplete(section) {
    var upload =
      q(
        ".sparc-custom-upload:not(.is-hidden)",
        section
      );

    if (
      !upload ||
      !visible(upload)
    ) {
      return true;
    }

    var status =
      q(
        ".sparc-custom-upload__status",
        upload
      );

    if (
      status &&
      status.classList.contains(
        "is-ok"
      )
    ) {
      return true;
    }

    var input =
      q(
        'input[type="file"]',
        upload
      );

    return !!(
      input &&
      input.files &&
      input.files.length
    );
  }

  function groupComplete(group) {
    if (
      !group ||
      !visible(group)
    ) {
      return true;
    }

    if (
      group.classList.contains(
        "sparc-card-grid"
      )
    ) {
      return selectedIn(
        group,
        [
          ".sparc-option-card.is-selected",
          ".sparc-choice.is-selected"
        ]
      );
    }

    if (
      group.classList.contains(
        "sparc-choice-grid"
      )
    ) {
      return selectedIn(
        group,
        [
          ".sparc-choice.is-selected",
          ".sparc-option-card.is-selected"
        ]
      );
    }

    if (
      group.classList.contains(
        "sparc-stitch-grid"
      )
    ) {
      return selectedIn(
        group,
        [
          ".sparc-stitch.is-selected"
        ]
      );
    }

    if (
      group.classList.contains(
        "sparc-mounting-grid"
      )
    ) {
      return selectedIn(
        group,
        [
          ".sparc-mounting-card.is-selected"
        ]
      );
    }

    return true;
  }

  function conditionalBlockComplete(block) {
    if (
      !block ||
      !visible(block)
    ) {
      return true;
    }

    var groups =
      qa(
        [
          ".sparc-card-grid",
          ".sparc-choice-grid",
          ".sparc-stitch-grid",
          ".sparc-mounting-grid"
        ].join(","),
        block
      ).filter(
        function (group) {
          return !group.parentElement.closest(
            ".sparc-card-grid," +
            ".sparc-choice-grid," +
            ".sparc-stitch-grid," +
            ".sparc-mounting-grid"
          );
        }
      );

    for (
      var i = 0;
      i < groups.length;
      i++
    ) {
      if (
        !groupComplete(
          groups[i]
        )
      ) {
        return false;
      }
    }

    var selects =
      qa(
        "select.sparc-select",
        block
      ).filter(visible);

    for (
      var j = 0;
      j < selects.length;
      j++
    ) {
      if (
        !selectHasValue(
          selects[j]
        )
      ) {
        return false;
      }
    }

    return true;
  }

  function baseVisibleGroups(section) {
    var inner =
      q(
        ".sparc-accordion__inner",
        section
      ) || section;

    var selectors = [
      ".sparc-card-grid",
      ".sparc-choice-grid",
      ".sparc-stitch-grid",
      ".sparc-mounting-grid"
    ].join(",");

    return qa(
      selectors,
      inner
    ).filter(
      function (group) {
        if (!visible(group)) return false;

        if (
          group.closest(
            ".sparc-conditional"
          )
        ) {
          return false;
        }

        var parentGroup =
          group.parentElement &&
          group.parentElement.closest(
            selectors
          );

        return !parentGroup;
      }
    );
  }

  function requiredSectionValid(item) {
    var section =
      item.section;

    var summary =
      q(
        ".sparc-accordion__summary",
        section
      );

    var summaryText =
      summary
        ? clean(
            summary.textContent
          )
        : "";

    if (
      invalidSummaryText(
        summaryText
      )
    ) {
      return false;
    }

    var groups =
      baseVisibleGroups(
        section
      );

    for (
      var i = 0;
      i < groups.length;
      i++
    ) {
      if (
        !groupComplete(
          groups[i]
        )
      ) {
        return false;
      }
    }

    var blocks =
      visibleConditionalBlocks(
        section
      );

    for (
      var j = 0;
      j < blocks.length;
      j++
    ) {
      if (
        !conditionalBlockComplete(
          blocks[j]
        )
      ) {
        return false;
      }
    }

    if (
      !customUploadComplete(
        section
      )
    ) {
      return false;
    }

    return true;
  }

  function optionalSectionValid(item) {
    var blocks =
      visibleConditionalBlocks(
        item.section
      );

    for (
      var i = 0;
      i < blocks.length;
      i++
    ) {
      if (
        !conditionalBlockComplete(
          blocks[i]
        )
      ) {
        return false;
      }
    }

    var summary =
      q(
        ".sparc-accordion__summary",
        item.section
      );

    if (
      summary &&
      clean(
        summary.textContent
      ).toLowerCase().indexOf(
        "required"
      ) !== -1
    ) {
      return false;
    }

    return true;
  }

  function sectionValid(item) {
    if (!item) return false;

    if (
      item.name === "summary"
    ) {
      return false;
    }

    if (
      OPTIONAL_SECTIONS[
        item.name
      ]
    ) {
      return optionalSectionValid(
        item
      );
    }

    return requiredSectionValid(
      item
    );
  }

  function setVisualState(
    item,
    stateName
  ) {
    if (!item) return;

    var isComplete =
      stateName === "complete";

    var isIncomplete =
      stateName === "incomplete";

    item.committed =
      isComplete;

    item.incomplete =
      isIncomplete;

    [
      item.section,
      item.head,
      item.tab
    ].forEach(
      function (node) {
        if (!node) return;

        node.classList.toggle(
          "sparc-section-committed",
          isComplete
        );

        node.classList.toggle(
          "sparc-section-incomplete",
          isIncomplete
        );
      }
    );
  }

  function celebrate(item) {
    if (!item) return;

    /*
      Temporary classes let the complete tab/header participate in the
      confirmation moment without permanently changing their layout.
    */
    if (item.tab) {
      item.tab.classList.remove(
        "sparc-completion-celebrating"
      );

      void item.tab.offsetWidth;

      item.tab.classList.add(
        "sparc-completion-celebrating"
      );

      window.setTimeout(
        function () {
          item.tab.classList.remove(
            "sparc-completion-celebrating"
          );
        },
        1050
      );
    }

    if (item.head) {
      item.head.classList.remove(
        "sparc-completion-celebrating"
      );

      void item.head.offsetWidth;

      item.head.classList.add(
        "sparc-completion-celebrating"
      );

      window.setTimeout(
        function () {
          item.head.classList.remove(
            "sparc-completion-celebrating"
          );
        },
        1100
      );
    }

    if (item.tabBadge) {
      item.tabBadge.classList.remove(
        "sparc-tab-complete-mark--celebrate"
      );

      void item.tabBadge.offsetWidth;

      item.tabBadge.classList.add(
        "sparc-tab-complete-mark--celebrate"
      );

      window.setTimeout(
        function () {
          item.tabBadge.classList.remove(
            "sparc-tab-complete-mark--celebrate"
          );
        },
        1050
      );
    }

    if (item.headBadge) {
      item.headBadge.classList.remove(
        "sparc-accordion-complete-mark--celebrate"
      );

      void item.headBadge.offsetWidth;

      item.headBadge.classList.add(
        "sparc-accordion-complete-mark--celebrate"
      );

      window.setTimeout(
        function () {
          item.headBadge.classList.remove(
            "sparc-accordion-complete-mark--celebrate"
          );
        },
        1100
      );
    }
  }


  function celebrateIncomplete(item) {
    if (!item) return;

    if (item.tab) {
      item.tab.classList.remove(
        "sparc-incomplete-celebrating"
      );

      void item.tab.offsetWidth;

      item.tab.classList.add(
        "sparc-incomplete-celebrating"
      );

      window.setTimeout(
        function () {
          item.tab.classList.remove(
            "sparc-incomplete-celebrating"
          );
        },
        950
      );
    }

    if (item.head) {
      item.head.classList.remove(
        "sparc-incomplete-celebrating"
      );

      void item.head.offsetWidth;

      item.head.classList.add(
        "sparc-incomplete-celebrating"
      );

      window.setTimeout(
        function () {
          item.head.classList.remove(
            "sparc-incomplete-celebrating"
          );
        },
        1000
      );
    }

    if (item.tabBadge) {
      item.tabBadge.classList.remove(
        "sparc-tab-complete-mark--incomplete-celebrate"
      );

      void item.tabBadge.offsetWidth;

      item.tabBadge.classList.add(
        "sparc-tab-complete-mark--incomplete-celebrate"
      );

      window.setTimeout(
        function () {
          item.tabBadge.classList.remove(
            "sparc-tab-complete-mark--incomplete-celebrate"
          );
        },
        950
      );
    }

    if (item.headBadge) {
      item.headBadge.classList.remove(
        "sparc-accordion-complete-mark--incomplete-celebrate"
      );

      void item.headBadge.offsetWidth;

      item.headBadge.classList.add(
        "sparc-accordion-complete-mark--incomplete-celebrate"
      );

      window.setTimeout(
        function () {
          item.headBadge.classList.remove(
            "sparc-accordion-complete-mark--incomplete-celebrate"
          );
        },
        1000
      );
    }
  }

  function commitSection(name) {
    var item =
      sectionMap[name];

    if (
      !item ||
      name === "summary"
    ) {
      return;
    }

    item.valid =
      sectionValid(
        item
      );

    var wasComplete =
      !!committedSections[
        name
      ];

    var wasIncomplete =
      !!incompleteSections[
        name
      ];

    if (!item.valid) {
      committedSections[
        name
      ] = false;

      incompleteSections[
        name
      ] = true;

      setVisualState(
        item,
        "incomplete"
      );

      /*
        Animate the red warning only when the customer has just left this
        section incomplete for the first time since its last state change.
        Re-clicking through an already-red section does not keep nagging.
      */
      if (!wasIncomplete) {
        celebrateIncomplete(
          item
        );
      }

      return;
    }

    committedSections[
      name
    ] = true;

    incompleteSections[
      name
    ] = false;

    setVisualState(
      item,
      "complete"
    );

    if (!wasComplete) {
      celebrate(
        item
      );
    }
  }

  function refreshValidity() {
    Object.keys(
      sectionMap
    ).forEach(
      function (name) {
        if (
          name === "summary"
        ) {
          return;
        }

        var item =
          sectionMap[name];

        item.valid =
          sectionValid(
            item
          );

        /*
          If a previously-green section is edited into an invalid state,
          remove the green success state while the customer is working.
          Red is applied only if they leave the section still incomplete.
        */
        if (
          committedSections[
            name
          ] &&
          !item.valid
        ) {
          committedSections[
            name
          ] = false;

          incompleteSections[
            name
          ] = false;

          setVisualState(
            item,
            "neutral"
          );
        }

        /*
          A previously-red section stays red while being corrected.
          It becomes green only when the customer leaves it valid.
        */
        if (
          incompleteSections[
            name
          ]
        ) {
          setVisualState(
            item,
            "incomplete"
          );
        }
      }
    );

    updateSummaryState();
  }

  function allSelectionSectionsCommitted() {
    var names =
      Object.keys(
        sectionMap
      ).filter(
        function (name) {
          return (
            name !== "summary"
          );
        }
      );

    if (!names.length) return false;

    return names.every(
      function (name) {
        return (
          !!committedSections[
            name
          ]
        );
      }
    );
  }

  function updateSummaryState() {
    var item =
      sectionMap.summary;

    if (!item) return;

    var complete =
      allSelectionSectionsCommitted();

    item.committed =
      complete;

    [
      item.section,
      item.head,
      item.tab
    ].forEach(
      function (node) {
        if (!node) return;

        node.classList.toggle(
          "sparc-summary-ready",
          complete
        );
      }
    );

    /*
      Summary gets a quieter "ready" treatment rather than the same
      completed check, because there is no next tab after Summary to
      confirm it in the same way.
    */
  }

  function currentTabSection() {
    var activeTab =
      q(
        ".sparc-config-tabs .sparc-config-tab.is-active," +
        ".sparc-config-tabs .sparc-config-tab.active," +
        ".sparc-config-tabs .sparc-config-tab[aria-selected='true']",
        panel
      );

    if (
      activeTab &&
      activeTab.dataset.sparcCompletionSection
    ) {
      return activeTab.dataset.sparcCompletionSection;
    }

    /*
      Fallback: visible/open accordion.
    */
    var open =
      qa(
        ".sparc-accordion[data-section]",
        panel
      ).find(
        function (section) {
          return (
            section.classList.contains(
              "is-open"
            ) ||
            section.classList.contains(
              "is-active"
            ) ||
            section.getAttribute(
              "aria-expanded"
            ) === "true"
          );
        }
      );

    return open
      ? open.dataset.section
      : "";
  }

  function navigationTargetFromEvent(event) {
    var target =
      event.target;

    if (
      !target ||
      !target.closest
    ) {
      return null;
    }

    /*
      Route 1: upper configurator tabs.
    */
    var tab =
      target.closest(
        ".sparc-config-tab[data-sparc-completion-section]"
      );

    if (tab) {
      return {
        type: "top-tab",
        name:
          tab.dataset.sparcCompletionSection ||
          ""
      };
    }

    /*
      Route 2: accordion/option section headers.
      These are the large 01/02/03... rows inside the configurator.
    */
    var head =
      target.closest(
        ".sparc-accordion__head[data-sparc-completion-section]"
      );

    if (head) {
      return {
        type: "accordion",
        name:
          head.dataset.sparcCompletionSection ||
          ""
      };
    }

    return null;
  }

  function onNavigationClick(event) {
    var destination =
      navigationTargetFromEvent(
        event
      );

    if (
      !destination ||
      !destination.name
    ) {
      return;
    }

    var nextName =
      destination.name;

    /*
      Commit the section the customer is LEAVING.
      It does not matter whether they leave through an upper tab or an
      accordion section header; both navigation methods behave identically.
    */
    var leaving =
      activeSectionName ||
      currentTabSection();

    if (
      leaving &&
      leaving !== nextName
    ) {
      touchedSections[
        leaving
      ] = true;

      commitSection(
        leaving
      );
    }

    activeSectionName =
      nextName;

    scheduleUpdate();
  }

  function markTouched(event) {
    var target =
      event.target;

    if (
      !target ||
      !target.closest
    ) {
      return;
    }

    var section =
      target.closest(
        ".sparc-accordion[data-section]"
      );

    if (section) {
      touchedSections[
        section.dataset.section
      ] = true;
    }
  }

  function scheduleUpdate() {
    window.clearTimeout(
      updateTimer
    );

    updateTimer =
      window.setTimeout(
        function () {
          refreshValidity();
        },
        70
      );
  }

  function installEvents() {
    panel.addEventListener(
      "click",
      function (event) {
        onNavigationClick(
          event
        );

        markTouched(
          event
        );
      },
      true
    );

    panel.addEventListener(
      "change",
      function (event) {
        markTouched(
          event
        );

        scheduleUpdate();
      },
      true
    );

    panel.addEventListener(
      "input",
      function (event) {
        markTouched(
          event
        );

        scheduleUpdate();
      },
      true
    );
  }

  function installObserver() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    observer =
      new MutationObserver(
        function (records) {
          var relevant =
            records.some(
              function (record) {
                if (
                  record.type ===
                  "characterData"
                ) {
                  return true;
                }

                var target =
                  record.target;

                if (
                  !target ||
                  !target.classList
                ) {
                  return true;
                }

                return !(
                  target.classList.contains(
                    "sparc-tab-complete-mark"
                  ) ||
                  target.classList.contains(
                    "sparc-accordion-complete-mark"
                  )
                );
              }
            );

          if (relevant) {
            scheduleUpdate();
          }
        }
      );

    observer.observe(
      panel,
      {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: [
          "class",
          "hidden",
          "value",
          "aria-hidden",
          "aria-selected",
          "aria-expanded"
        ]
      }
    );
  }

  function attach() {
    var found =
      activePanel();

    if (!found) {
      return false;
    }

    panel = found;
    sectionMap = {};
    committedSections = {};
    incompleteSections = {};
    touchedSections = {};

    if (!buildMap()) {
      panel = null;
      return false;
    }

    activeSectionName =
      currentTabSection() ||
      Object.keys(
        sectionMap
      )[0] ||
      "";

    installEvents();
    installObserver();
    refreshValidity();

    console.info(
      "[SPARC CONFIG COMPLETION V1.4] Active.",
      {
        panel: panel.id,
        activeSection:
          activeSectionName,
        sections:
          Object.keys(
            sectionMap
          )
      }
    );

    return true;
  }

  function start() {
    var attempts = 0;

    startupTimer =
      window.setInterval(
        function () {
          attempts += 1;

          if (
            attach() ||
            attempts >= 80
          ) {
            window.clearInterval(
              startupTimer
            );

            startupTimer = null;
          }
        },
        250
      );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {
        once: true
      }
    );
  } else {
    start();
  }
})();
